module.exports = __webpack_public_path__ + "img/cardiff-city.1bdf8334.png";